/**
 * Enumeration which represents the week days.
 */
export var Day = /*#__PURE__*/function (Day) {
  /**
   * The Sunday value with an underlying `0` number value.
   */
  Day[Day["Sunday"] = 0] = "Sunday";
  /**
   * The Monday value with an underlying `1` number value.
   */
  Day[Day["Monday"] = 1] = "Monday";
  /**
   * The Tuesday value with an underlying `2` number value.
   */
  Day[Day["Tuesday"] = 2] = "Tuesday";
  /**
   * The Wednesday value with an underlying `3` number value.
   */
  Day[Day["Wednesday"] = 3] = "Wednesday";
  /**
   * The Thursday value with an underlying `4` number value.
   */
  Day[Day["Thursday"] = 4] = "Thursday";
  /**
   * The Friday value with an underlying `5` number value.
   */
  Day[Day["Friday"] = 5] = "Friday";
  /**
   * The Saturday value with an underlying `6` number value.
   */
  Day[Day["Saturday"] = 6] = "Saturday";
  return Day;
}(Day || {});